import { SKELETON_KEY } from './skeletonFactory';

export function skeletonARMarker() {
  return {
    blobUrl: SKELETON_KEY
  };
}
